import type { HelpFile } from '../../types/help'
import { DetectionHistoryCardTestIds } from '../../../testids/DetectionHistoryCardTestIds'

export const detectionHistoryCardHelp: HelpFile = {
  docPage: '/docs/governance/restriction-rules',
  texts: {
    [DetectionHistoryCardTestIds.detectionHistoryCard]:
      'Letzte Erkennungsläufe für diese Restriktionsregel — Status, geprüfte Identitäten sowie gefundene und behobene Verstöße pro Lauf.',
    [DetectionHistoryCardTestIds.cardTitleDetectionHistory]: null,
    [DetectionHistoryCardTestIds.detectionLoading]: null,
    [DetectionHistoryCardTestIds.detectionEmpty]: null,
    [DetectionHistoryCardTestIds.detectionError]: null,
    [DetectionHistoryCardTestIds.linkViewAllDetections]:
      'Vollständigen Erkennungsverlauf einschließlich älterer Läufe und Detailangaben pro Verstoß öffnen.',
  },
}
